import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { BaseForm } from '@forms/base.form';
import { Card } from '@models/settings/billing/card.model';

declare let Stripe: any;

@Component({
    selector: 'app-payment-information-form',
    templateUrl: './payment-information.template.html',
    styleUrls: ['./payment-information.style.scss'],
})
export class PaymentInformationForm extends BaseForm implements OnInit {
    stripe: any | null;
    elements: any | null;
    cardNumber: any | null;

    name: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    province: string | null;
    postalCode: string | null;
    country: string | null;

    cardNumberError: string | null;
    cardExpiryError: string | null;
    cardCvcError: string | null;

    elementStyles: object = {
        base: {
            fontSize: '15px',
            fontWeight: 400,
            color: 'var(--grey-900)',
        },
    };

    ngOnInit(): void {
        this.initializeStripe();
        this.createCardNumberElement();
        this.createCardExpiryElement();
        this.createCardCvcElement();
    }

    reset(): void {
        this.name = null;
        this.addressLine1 = null;
        this.addressLine2 = null;
        this.city = null;
        this.province = null;
        this.postalCode = null;
        this.country = null;
    }

    retrieveToken(): Promise<string | Card> {
        return new Promise<Card | string>((resolve, reject) => {
            this.stripe
                .createToken(this.cardNumber, {
                    name: this.name,
                    address_line1: this.addressLine1,
                    address_line2: this.addressLine2,
                    address_city: this.city,
                    address_state: this.province,
                    address_zip: this.postalCode,
                    address_country: this.country,
                })
                .then((result) => {
                    if (result.error) {
                        reject(result.error.message);
                        return;
                    }

                    resolve(
                        new Card({
                            token: result.token.id,
                        })
                    );
                });
        });
    }

    private initializeStripe(): void {
        this.stripe = Stripe(environment.stripeKey);
        this.elements = this.stripe.elements();
    }

    private createCardNumberElement(): void {
        this.cardNumber = this.elements.create('cardNumber', { style: this.elementStyles });
        this.cardNumber.mount('#cardNumber');
        this.cardNumber.addEventListener('change', (event) => {
            this.cardNumberError = event.error ? event.error.message : null;
        });
    }
    private createCardExpiryElement(): void {
        const cardExpiry = this.elements.create('cardExpiry', { style: this.elementStyles });
        cardExpiry.mount('#cardExpiry');
        cardExpiry.addEventListener('change', (event) => {
            this.cardExpiryError = event.error ? event.error.message : null;
        });
    }
    private createCardCvcElement(): void {
        const cardCvc = this.elements.create('cardCvc', { style: this.elementStyles });
        cardCvc.mount('#cardCvc');

        cardCvc.addEventListener('change', (event) => {
            this.cardCvcError = event.error ? event.error.message : null;
        });
    }
}
